import {
  type VehicleServiceRequestId,
  VEHICLE_SERVICE_REQUEST_IDS,
} from "../types";

const LABELS: Record<VehicleServiceRequestId, string> = {
  oil_change: "Oil change",
  tire_service: "Tire service",
  windshield_wiper: "Windshield wiper",
  windshield_cleaning_fluid: "Windshield cleaning fluid",
  mechanical_issue: "Mechanical issue",
};

export type VehicleServiceRequestOption = {
  id: VehicleServiceRequestId;
  label: string;
};

/** Stable-ordered options for comboboxes (id matches API `service_requests`). */
export const VEHICLE_SERVICE_REQUEST_OPTIONS: VehicleServiceRequestOption[] =
  VEHICLE_SERVICE_REQUEST_IDS.map((id) => ({
    id,
    label: LABELS[id],
  }));

export function getVehicleServiceRequestLabel(id: VehicleServiceRequestId): string {
  return LABELS[id];
}

export function uniqueVehicleServiceRequests(ids: readonly string[]): VehicleServiceRequestId[] {
  return VEHICLE_SERVICE_REQUEST_IDS.filter((k) => ids.includes(k));
}
